import { Location } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DetailedRoute, OpenTripPlannerService } from '@ridango/components';
import { Observable, of } from 'rxjs';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { PatternScheduleSharedService } from '../../../services/pattern-schedule-shared.service';

@Component({
    selector: 'rwidget-pattern-schedule-on-stop-additional-info',
    templateUrl: './pattern-schedule-on-stop-additional-info.component.html',
    styleUrls: ['./pattern-schedule-on-stop-additional-info.component.scss']
})
export class PatternScheduleOnStopAdditionalInfoComponent implements OnDestroy {
    public route$: Observable<DetailedRoute>;

    constructor(
        private _location: Location,
        private activatedRoute: ActivatedRoute,
        private otpService: OpenTripPlannerService,
        private patternScheduleShared: PatternScheduleSharedService
    ) {
        this.route$ = this.patternScheduleShared.getRoute().pipe(
            take(1),
            switchMap((cachedRoute) => {
                if (cachedRoute) {
                    return of(cachedRoute);
                } else {
                    return this.activatedRoute.params.pipe(
                        map(({ patternId }) => patternId.split('::')[0]),
                        filter(Boolean),
                        switchMap((routeId: string) => this.otpService.getRoute(routeId))
                    );
                }
            })
        );
    }

    public navigateBack() {
        this._location.back();
    }

    ngOnDestroy() {
        this.patternScheduleShared.clearRoute();
    }
}
